import { render, staticRenderFns } from "./LoginByPhone.vue?vue&type=template&id=0bccbca9&scoped=true"
import script from "./LoginByPhone.vue?vue&type=script&lang=js"
export * from "./LoginByPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccbca9",
  null
  
)

export default component.exports